function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState } from 'react';
var TableHeader = function TableHeader(_ref) {
  var table = _ref.table,
    actions = _ref.actions,
    onSort = _ref.onSort;
  var _useState = useState(uuid()),
    _useState2 = _slicedToArray(_useState, 1),
    id = _useState2[0];
  var layout = table.layout,
    sort = table.sort;
  return /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, actions && /*#__PURE__*/React.createElement("th", {
    style: {
      padding: 0
    }
  }), layout.map(function (x) {
    var _table$sort, _x$th$sort;
    var visible = x.visible;
    if (!visible) return;
    return /*#__PURE__*/React.createElement("th", {
      className: [x.size === 'contain' ? 'table__contain' : ''].join(' '),
      key: "".concat(id).concat(x.key)
    }, x.title, ((_table$sort = table.sort) === null || _table$sort === void 0 ? void 0 : _table$sort.disabled) !== true && !((_x$th$sort = x.th.sort) !== null && _x$th$sort !== void 0 && _x$th$sort.disabled) && /*#__PURE__*/React.createElement("div", {
      className: "table__sort",
      onClick: function onClick() {
        return onSort(x.key);
      }
    }, /*#__PURE__*/React.createElement("i", {
      className: "fa fa-sort-up ".concat((sort === null || sort === void 0 ? void 0 : sort.by) === x.key && sort !== null && sort !== void 0 && sort.asc ? 'active' : '')
    }), /*#__PURE__*/React.createElement("i", {
      className: "fa fa-sort-down ".concat((sort === null || sort === void 0 ? void 0 : sort.by) === x.key && !(sort !== null && sort !== void 0 && sort.asc) ? 'active' : '')
    })));
  })));
};
export default TableHeader;